import { Dialog } from "@headlessui/react"
import React, { FC, useState } from "react"
import { X } from "heroicons-react"
import { User } from "../../../../../types"
import { KButton, KInput, KSpan, KTextArea, KTitleSpan, KTooltip } from "kahuna-base-react-components"
import InfoCircleIcon from "../../../../../assets/analytics_icons/info-circle.svg"
import { notifications, users } from "../../../../../apis"
import { errorFilledToastOptions, NOTIFICATION_TYPES, successFilledToastOptions } from "../../../../../constants"
import { toast } from "react-toastify"

type AdminNotificationSendModalProps = {
  open: boolean
  onClose: () => void
  user: User
}
const AdminNewUserTakedownModal: FC<AdminNotificationSendModalProps> = (props) => {
  const { onClose, open } = props

  const [albumIds, setAlbumIds] = useState("")
  const [confirmedOfferId, setConfirmedOfferId] = useState("")
  const [loading, setLoading] = useState(false)

  const onSave = (id: number | undefined) => {
    if (!id) return

    setLoading(true)
    users("/create_or_update_user_takedown/", "post", {
      user_id: id.toString(),
      album_ids: albumIds,
      confirmed_offer_id: confirmedOfferId
    }).then((resp) => {
      setLoading(false)
      if (resp && resp.status === 200) {
        toast.success("User Takedown saved successfully.", successFilledToastOptions)

        onClose()
      } else {
        toast.error("Error saving User Takedown.", errorFilledToastOptions)
      }
    })
  }

  return (
    <Dialog
      open={open}
      onClose={() => {
        onClose()
      }}
      className="relative"
    >
      <div className="fixed inset-0 bg-[rgba(0,0,0,0.3)]" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <div>
          <div className={`flex justify-end`}>
            <X
              className="h-4 cursor-pointer mt-1"
              style={{ position: "absolute" }}
              onClick={() => {
                onClose()
              }}
            />
          </div>
          <div
            className="bg-white elev-b-sm rounded-lg overflow-hidden w-[600px] flex flex-col gap-4"
            style={{ overflowY: "auto", padding: 42 }}
          >
            <KTitleSpan text={"Create / Update User Takedown"} fontSize={32} />
            <div className="flex flex-row gap-1">
              <KSpan text="Selected User:" color="#000" />
              <KSpan text={`${props.user?.firstName} ${props.user?.lastName}`} color="#000" fontWeight={500} />
            </div>

            <KTextArea
              dataTestId="album-ids-content"
              value={albumIds}
              onChange={(text) => {
                setAlbumIds(text)
              }}
              placeholder="Spotify album ids. Example: 6pngQ1BGnsddTXtAJQUkF7,3iMbRu5525UiZD8PI5IpNb"
              maxHeight={200}
              height={120}
            />

            <div className="flex flex-col gap-1 mt-2">
              <div className="flex items-start gap-1.5">
                <KSpan text="Confirmed Offer Id" color="#111" fontWeight={500}/>
                <KTooltip
                  position="right"
                  showArrow
                  padding="0px 4px"
                  backgroundColor="#111"
                  children={
                    <img src={InfoCircleIcon} className="w-4 h-4 cursor-default" alt="info-takedown" />
                  }
                  content={
                    <div className="w-[220px] h-auto whitespace-normal p-1">
                      <KSpan
                        text="A Confirmed Offer ID is required to generate the takedown batch and display contract details correctly."
                        color="#FFF"
                        fontSize={12}
                        lineHeight="16px"
                      />
                    </div>
                  }
                />
              </div>
              <KInput
                placeholder="Enter to see Contract Takedown Batches"
                value={confirmedOfferId}
                onChange={(value) => setConfirmedOfferId(value)}
              />
            </div>
            <div className="flex pt-4" style={{ borderTop: "1px solid rgb(220 220 220)" }}>
              <KButton
                text="Cancel"
                background="white"
                shadowDisabled={true}
                onClick={() => {
                  onClose()
                }}
              />
              <KButton
                dataTestId="user-takedown-confirm-button"
                text="Confirm"
                background="black"
                textColor="white"
                onClick={() => onSave(props.user.id)}
                disabled={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  )
}

export default AdminNewUserTakedownModal
